/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'outline/16/star': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="none" stroke-linecap="round" stroke-linejoin="round" data-cap="butt" d="M8 .867l2.318 4.696 5.182.753-3.75 3.655.885 5.162L8 12.696l-4.635 2.437.885-5.162L.5 6.316l5.182-.753L8 .867z" _stroke="#272c33"/>'
  }
})
